import { ComponentProps, ReactNode, useCallback, useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { createContext } from '@factorialco/deprecated-design-system'
import type { PageHeader } from '@factorialco/f0-react/dist/experimental'

type StatusTag = ComponentProps<typeof PageHeader>['statusTag']
type PageStatus = {
  pageStatus: StatusTag
  setPageStatus: (newPageStatus: StatusTag) => void
  clearPageStatus: () => void
}
const { context: PageStatusContext, hook: usePageStatus } = createContext<PageStatus>()

const PageStatusProvider = ({ children }: { children: ReactNode }) => {
  const [statusTag, setStatusTag] = useState<StatusTag>()
  const { pathname } = useLocation()

  const setPageStatus = useCallback((tag: StatusTag) => {
    setStatusTag((prev) => {
      const differByValue = prev?.text !== tag?.text || prev?.variant !== tag?.variant

      return differByValue ? tag : prev
    })
  }, [])

  const clearPageStatus = useCallback(() => {
    setStatusTag(undefined)
  }, [])

  useEffect(() => clearPageStatus, [pathname])

  const value: PageStatus = useMemo(
    () => ({ pageStatus: statusTag, setPageStatus, clearPageStatus }),
    [statusTag, setPageStatus]
  )

  return <PageStatusContext.Provider value={value}>{children}</PageStatusContext.Provider>
}

export { PageStatusProvider, usePageStatus }
